module.exports = __webpack_public_path__ + "static/media/male_default.1cf0f534.png";